import bizLogo from "../../assets/biz-consultancy-logo.png";

export function LeaveScreen({ onRejoin }) {
  return (
    <div className="biz-shell flex min-h-[100dvh] items-center justify-center px-4">
      <div className="pointer-events-none absolute inset-0 biz-grid-overlay" aria-hidden />
      <div className="biz-panel relative z-10 w-full max-w-md p-8 text-center animate-fadeUp sm:p-10">
        <img
          src={bizLogo}
          alt="BIZ Consultancy"
          className="mx-auto mb-6 h-16 w-16 rounded-2xl object-cover shadow-soft ring-1 ring-biz-line"
        />
        <h1 className="font-display text-3xl font-semibold text-biz-ink">
          You&apos;ve left the meeting
        </h1>
        <p className="mt-3 font-sans text-sm leading-relaxed text-biz-mute">
          Thanks for using BIZ Consultancy Meeting. Rejoin anytime with the same
          link.
        </p>
        <button type="button" className="biz-btn-primary mt-8" onClick={onRejoin}>
          Rejoin meeting
        </button>
        <a
          href="https://www.bizconsultancy.iid.org.in/"
          target="_blank"
          rel="noreferrer"
          className="mt-4 inline-block text-sm font-medium text-biz-forest underline-offset-4 hover:underline"
        >
          Back to BIZ portal
        </a>
      </div>
    </div>
  );
}
